import { MsUser } from "@/types/msuser";
import { Avatar, Box, Flex } from "@chakra-ui/react";

type Props = {
  letter: MsUser;
  isActive: boolean;
  handClickMsuser: (item: MsUser)=>void;
};

const PrivateLetterItem = (props:Props) => {
  const {letter, isActive, handClickMsuser} = props;
  return (
    <>
      <Flex
        p="15px"
        justifyContent="space-between"
        _hover={{
          bg: "rgba(238, 241, 247, 0.5)",
        }}
        bg={isActive ? "rgba(238, 241, 247, 0.5)" : ""}
        borderBottom="1px solid #DCE0EB"
        onClick={()=>handClickMsuser(letter)}
      >
        <Flex mr={"10px"} flex={1}>
          <Avatar size="sm" mr="18px" src={`/api/v4/users/${letter.from_user.id}/image`} />
          <Box>
            <Box mb="6px" fontWeight="700" color={"#27314D"} fontSize="13px">
              {letter.from_user.user_name}
            </Box>
            <Box fontSize="13px" display={"inline"}>
              {letter.content}
            </Box>
            <Box mt="10px" color={"#8E94A9"} fontSize="10px">
              {letter.createat}
            </Box>
          </Box>
        </Flex>
        <Box bg="#EA0000" mt="10px" w="6px" h="6px" borderRadius="6px"></Box>
      </Flex>
    </>
  );
};

export default PrivateLetterItem;
